import bgShareImage from "../../../assets/background-seleccion.jpg";
import simulatorSelectionData from "../json-selections/simulatorSelectionData.json";
import backgroundEsc from "../../../assets/escudo-mx.png";
import { PATH } from "../../../constantes/constantes";

export const selectionMXConfig = {
  data: simulatorSelectionData,
  backgroundEscudo: backgroundEsc,
  shareImage: bgShareImage,
  shareUrl: PATH + "/futbol/mundial-2026/arma-tu-convocatoria-de-mexico-para-el-mundial-2026-con-el-simulador-de-claro-sports/",
  shareText: "Mi lista tricolor para el Mundial ",
  shareTitle: "Mi lista tricolor para el Mundial ",
  shareFileName: "mi-seleccion-mx.png",
  accentColor: "var(--color-red)",
  accentColorAlt: "var(--color-green-strendus)",
  selectedColor: "var(--color-red)",
  title: "Mi Selección Nacional",
   shareTextColor: "var(--color-white)"
};